import React from 'react'
import PropTypes from 'prop-types'

import { Button, Row } from 'components/patterns'

import { FooterStyled, FooterColumn } from './BatchImport.styles'

const BatchImportFooter = (props) => {
  const { buttonConfig } = props

  return (
    <FooterStyled>
      <Row>
        <FooterColumn justifyContent="center" alignItems="center" span={24}>
          {buttonConfig.map(({ text, disabled, onClick, type, iconProps }) => (
            <Button
              disabled={disabled}
              key={text}
              onClick={onClick}
              type={type}
              iconProps={iconProps}
            >
              {text}
            </Button>
          ))}
        </FooterColumn>
      </Row>
    </FooterStyled>
  )
}

BatchImportFooter.propTypes = {
  buttonConfig: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      disabled: PropTypes.bool,
      onClick: PropTypes.func,
      type: PropTypes.string,
    })
  ),
}

export default BatchImportFooter
